import { Box } from '@mui/material';
import MigrationItemViewDTO from '@src/adapters/dto/migration/MigrationItemViewDTO';
import useCreateMigrationItemWithInventoryLazy from '@src/adapters/hooks/migration/useCreateMigrationItemWithInventory';
import InventoryAutoComplete from '@src/components/inventory/InventoryAutoComplete';
import { useSnackbar } from 'notistack';
import { useEffect } from 'react';
import { useForm, useWatch } from 'react-hook-form';

interface Props {
  migrationId: string;
  inventoryItemAdded(item: MigrationItemViewDTO): void;
}

interface FormValues {
  inventory: { id: string | null; name: string | null };
}

function InventorySelection({ migrationId, inventoryItemAdded }: Props) {
  const { execute } = useCreateMigrationItemWithInventoryLazy();
  const { enqueueSnackbar } = useSnackbar();
  const { control, reset, setValue } = useForm<FormValues>({
    mode: 'all',
    defaultValues: {
      inventory: {
        id: null,
        name: null,
      },
    },
  });

  const selectedItem = useWatch({ control, name: 'inventory' });

  useEffect(() => {
    if (selectedItem && selectedItem.id) {
      execute({
        migrationId: migrationId,
        inventoryId: selectedItem.id,
      }).then((result) => {
        inventoryItemAdded(result.item);
        reset();
        enqueueSnackbar('Item Added', { variant: 'success' });
      });
    }
  }, [
    enqueueSnackbar,
    execute,
    inventoryItemAdded,
    migrationId,
    selectedItem,
    reset,
  ]);

  return (
    <>
      <Box
        sx={(theme) => ({
          padding: theme.spacing(3),
        })}>
        <InventoryAutoComplete
          control={control}
          name="inventory"
          label="Add Item"
          allowAdd={true}
          setValue={setValue}
        />
      </Box>
    </>
  );
}

export default InventorySelection;
